import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { styled } from '@stitches/react';

// 导入子页面组件（将在后续创建）
import AsicShopOverview from './AsicShopOverview';
import AsicShopProducts from './AsicShopProducts';
import AsicShopDetails from './AsicShopDetails';
import AsicShopCustomization from './AsicShopCustomization';

// ASIC商店容器样式
const AsicShopContainer = styled('div', {
  width: '100%',
  maxWidth: '1200px',
  margin: '0 auto',
  padding: '0 1rem'
});

/**
 * ASIC矿机商店模块主组件
 * 管理矿机商店相关路由
 */
const AsicShop: React.FC = () => {
  // const { t } = useTranslation(); // 暂时未使用
  
  return (
    <AsicShopContainer>
      <Routes>
        {/* ASIC矿机商店概览页面 */}
        <Route index element={<AsicShopOverview />} />
        
        {/* 矿机产品列表页面 */}
        <Route path="products" element={<AsicShopProducts />} />
        
        {/* 矿机详情页面 */}
        <Route path="details" element={<AsicShopDetails />} />
        
        {/* 矿机定制页面 */}
        <Route path="customization" element={<AsicShopCustomization />} />
        
        {/* 重定向到商店概览 */}
        <Route path="*" element={<Navigate to="/products/asic-shop" replace />} />
      </Routes>
    </AsicShopContainer>
  );
};

export default AsicShop; 